const wrapper = "_35sw1e4o0jc";
const arrowToFacit = "_35sal75hmh";
const container = "_35scq8lu2m";
const label = "_35sl1see1w5";
const inputWithChevronContainer = "_35si108v8ej";

export { arrowToFacit, container, inputWithChevronContainer, label, wrapper };
import "./container.facit.style.linaria.module.css";
//# sourceMappingURL=container.facit.style.js.map
